import React from "react";
import LogoVideo from "../assets/videos/valiram-logo-splash.mp4";

const SplashScreen = () => {  
  return (
    <div className="h-[100vh] flex justify-center items-center bg-black absolute z-20">     
      <video autoPlay muted className="w-3/5" playsInline>
        <source src={LogoVideo} type="video/mp4"></source>
      </video>
    </div>
  );
};

export default SplashScreen;
